import { Component, Inject, Input } from '@angular/core';
import Env from '@ridango/core/env';

@Component({
    selector: 'ridango-navigation-bar',
    templateUrl: './navigation-bar.component.html',
    styleUrls: ['./navigation-bar.component.css']
})
export class NavigationBarComponent {
    @Input() showOnMobile = false;

    constructor(@Inject('ENV') public env: Env) {}
}
